// extracted by css-extract-rspack-plugin
export default {"info":"Info_info__pdSeZ"};